(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-heat-pump-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatNumber = (value, digits = 1) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits
    }).format(value);

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const filter = root.querySelector('[data-series-filter]');
      const selectionStatus = root.querySelector('[data-selection-status]');
      const minimumInput = root.querySelector('[data-sizing-minimum]');
      const recommendedInput = root.querySelector('[data-sizing-recommended]');
      const sizingSummary = root.querySelector('[data-sizing-summary]');
      const empty = root.querySelector('[data-comparison-empty]');
      const tableWrap = root.querySelector('[data-comparison-table-wrap]');
      const table = root.querySelector('[data-comparison-table]');
      const limit = Number.parseInt(root.dataset.selectionLimit, 10) || 3;
      const selected = new Map();
      let sizing = { minimum: null, recommended: null, volume: null };

      const numberValue = (input) => {
        const value = Number.parseFloat(String(input.value || '').replace(',', '.'));
        return Number.isFinite(value) && value > 0 ? value : null;
      };

      const productFromCard = (card) => ({
        id: card.dataset.id,
        title: card.dataset.title,
        url: card.dataset.url,
        image: card.dataset.image,
        price: card.dataset.price,
        series: card.dataset.series,
        warmCondition: card.dataset.warmCondition,
        heatWarm: Number.parseFloat(card.dataset.heatWarm),
        heatCold: Number.parseFloat(card.dataset.heatCold),
        copWarm: card.dataset.copWarm,
        copCold: card.dataset.copCold,
        sound: card.dataset.sound,
        airRange: card.dataset.airRange,
        waterFlow: card.dataset.waterFlow,
        voltage: card.dataset.voltage,
        connection: card.dataset.connection,
        wifi: card.dataset.wifi === 'true'
      });

      const fitFor = (product) => {
        if (!sizing.minimum && !sizing.recommended) {
          return { key: 'open', label: root.dataset.fitOpen };
        }

        const minimum = sizing.minimum || sizing.recommended;
        const recommended = sizing.recommended || minimum;
        if (product.heatCold >= recommended) {
          return { key: 'recommended', label: root.dataset.fitRecommended };
        }
        if (product.heatCold >= minimum) {
          return { key: 'minimum', label: root.dataset.fitMinimum };
        }
        if (product.heatWarm >= minimum) {
          return { key: 'warm-only', label: root.dataset.fitWarmOnly };
        }
        return { key: 'too-small', label: root.dataset.fitTooSmall };
      };

      const updateSelectionStatus = (message = '') => {
        selectionStatus.textContent = message || root.dataset.selectionCount
          .replace('__count__', selected.size)
          .replace('__limit__', limit);
      };

      const createTextCell = (tag, value, scope) => {
        const cell = document.createElement(tag);
        if (scope) cell.scope = scope;
        cell.textContent = value;
        return cell;
      };

      const renderTable = () => {
        const products = Array.from(selected.values());
        empty.hidden = products.length > 0;
        tableWrap.hidden = products.length === 0;
        table.querySelector('thead').replaceChildren();
        table.querySelector('tbody').replaceChildren();

        if (!products.length) return;

        const headerRow = document.createElement('tr');
        headerRow.append(createTextCell('th', '', 'col'));

        products.forEach((product) => {
          const th = document.createElement('th');
          th.scope = 'col';
          const content = document.createElement('div');
          content.className = 'pwt24-heat-pump-comparison__table-product';

          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            content.append(image);
          }

          const title = document.createElement('a');
          title.href = product.url;
          title.textContent = product.title;
          content.append(title);

          const actions = document.createElement('div');
          actions.className = 'pwt24-heat-pump-comparison__table-actions';
          const productLink = document.createElement('a');
          productLink.href = product.url;
          productLink.textContent = root.dataset.productLink;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = root.dataset.remove;
          remove.addEventListener('click', () => {
            const card = cards.find((item) => item.dataset.id === product.id);
            if (card) toggleSelection(card);
          });
          actions.append(productLink, remove);
          content.append(actions);
          th.append(content);
          headerRow.append(th);
        });
        table.querySelector('thead').append(headerRow);

        const rows = [
          [root.dataset.rowFit, (product) => fitFor(product).label],
          [root.dataset.rowPrice, (product) => product.price],
          [root.dataset.rowSeries, (product) => product.series],
          [root.dataset.rowWarm, (product) => `${formatNumber(product.heatWarm)} kW (${product.warmCondition})`],
          [root.dataset.rowCold, (product) => `${formatNumber(product.heatCold)} kW (A15/W26)`],
          [root.dataset.rowCopWarm, (product) => product.copWarm],
          [root.dataset.rowCopCold, (product) => product.copCold],
          [root.dataset.rowSound, (product) => product.sound],
          [root.dataset.rowAir, (product) => product.airRange],
          [root.dataset.rowFlow, (product) => product.waterFlow],
          [root.dataset.rowVoltage, (product) => product.voltage],
          [root.dataset.rowConnection, (product) => product.connection],
          [root.dataset.rowWifi, (product) => product.wifi ? root.dataset.valueYes : root.dataset.valueNo]
        ];

        rows.forEach(([label, getter]) => {
          const row = document.createElement('tr');
          row.append(createTextCell('th', label, 'row'));
          products.forEach((product) => row.append(createTextCell('td', getter(product))));
          table.querySelector('tbody').append(row);
        });
      };

      const refreshFit = () => {
        cards.forEach((card) => {
          const fit = fitFor(productFromCard(card));
          const badge = card.querySelector('[data-fit-badge]');
          card.dataset.fit = fit.key;
          badge.textContent = fit.label;
          badge.hidden = fit.key === 'open';
        });
        renderTable();
      };

      const toggleSelection = (card) => {
        const id = card.dataset.id;
        if (selected.has(id)) {
          selected.delete(id);
          card.setAttribute('aria-pressed', 'false');
          updateSelectionStatus();
          renderTable();
          return;
        }

        if (selected.size >= limit) {
          updateSelectionStatus(root.dataset.selectionLimitMessage.replace('__limit__', limit));
          return;
        }

        selected.set(id, productFromCard(card));
        card.setAttribute('aria-pressed', 'true');
        updateSelectionStatus();
        renderTable();
      };

      const applySizing = (updateUrl = true) => {
        sizing.minimum = numberValue(minimumInput);
        sizing.recommended = numberValue(recommendedInput);
        if (sizing.minimum && sizing.recommended && sizing.recommended < sizing.minimum) {
          sizing.recommended = sizing.minimum;
          recommendedInput.value = sizing.minimum;
        }

        const hasSizing = Boolean(sizing.minimum || sizing.recommended);
        sizingSummary.hidden = !hasSizing;
        sizingSummary.textContent = hasSizing
          ? root.dataset.sizingSummary
            .replace('__minimum__', sizing.minimum ? `${formatNumber(sizing.minimum)} kW` : '–')
            .replace('__recommended__', sizing.recommended ? `${formatNumber(sizing.recommended)} kW` : '–')
          : '';

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (sizing.minimum) url.searchParams.set('min', sizing.minimum);
          else url.searchParams.delete('min');
          if (sizing.recommended) url.searchParams.set('recommended', sizing.recommended);
          else url.searchParams.delete('recommended');
          window.history.replaceState({}, '', url);
        }

        refreshFit();
      };

      const series = Array.from(new Set(cards.map((card) => card.dataset.series).filter(Boolean)));
      series.forEach((name) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        filter.append(option);
      });

      filter.addEventListener('change', () => {
        cards.forEach((card) => {
          card.hidden = Boolean(filter.value) && card.dataset.series !== filter.value;
        });
      });

      cards.forEach((card) => card.addEventListener('click', () => toggleSelection(card)));
      root.querySelector('[data-apply-sizing]').addEventListener('click', () => applySizing());
      root.querySelector('[data-reset-sizing]').addEventListener('click', () => {
        minimumInput.value = '';
        recommendedInput.value = '';
        sizing = { minimum: null, recommended: null, volume: null };
        applySizing();
      });

      const params = new URLSearchParams(window.location.search);
      const minimum = Number.parseFloat(params.get('min'));
      const recommended = Number.parseFloat(params.get('recommended'));
      const volume = Number.parseFloat(params.get('volume'));
      if (Number.isFinite(minimum) && minimum > 0) minimumInput.value = minimum;
      if (Number.isFinite(recommended) && recommended > 0) recommendedInput.value = recommended;
      if (Number.isFinite(volume) && volume > 0) sizing.volume = volume;

      applySizing(false);
      updateSelectionStatus();
      renderTable();
    };

    document.querySelectorAll('[data-pwt24-heat-pump-comparison]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pwt24-heat-pump-comparison]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-pool-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatNumber = (value, digits = 1) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits
    }).format(value);

    const roundUp = (value, step) => Math.ceil(value / step) * step;

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('[data-calculator-form]');
      const results = root.querySelector('[data-results]');
      const volumeInput = form.elements.volume;
      const volumeError = root.querySelector('[data-volume-error]');
      const volumeStatus = root.querySelector('[data-volume-status]');
      const pipeSizes = [
        { label: 'D50', innerDiameter: 43 },
        { label: 'D63', innerDiameter: 55 },
        { label: 'D75', innerDiameter: 66 },
        { label: 'D90', innerDiameter: 79 },
        { label: 'D110', innerDiameter: 97 }
      ];
      const filterSizes = [400, 450, 500, 600, 750, 900, 1050, 1200, 1400, 1600, 1800, 2000, 2200];

      const numberValue = (name) => Number.parseFloat(form.elements[name].value.replace(',', '.'));
      const selectedValue = (name) => form.elements[name].value;

      root.querySelector('[data-use-volume]').addEventListener('click', () => {
        const length = numberValue('length');
        const width = numberValue('width');
        const depth = numberValue('depth');

        if (![length, width, depth].every((value) => Number.isFinite(value) && value > 0)) {
          volumeStatus.textContent = '';
          form.elements.length.focus();
          return;
        }

        const volume = Math.round(length * width * depth * 10) / 10;
        volumeInput.value = volume;
        volumeStatus.textContent = `${root.dataset.volumeReady} ${formatNumber(volume)} m³`;
        volumeError.hidden = true;
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const volume = numberValue('volume');
        if (!Number.isFinite(volume) || volume <= 0 || volume > 250) {
          volumeError.hidden = false;
          results.hidden = true;
          volumeInput.focus();
          return;
        }

        volumeError.hidden = true;
        const temperature = Math.min(32, Math.max(24, numberValue('temperature') || 28));
        const filterHours = Math.min(24, Math.max(6, numberValue('filter_hours') || 12));
        const season = selectedValue('season');
        const cover = selectedValue('cover');
        const heating = selectedValue('heating');
        const pipeLength = Math.min(100, Math.max(1, numberValue('pipe_length') || 10));

        let heatFactor = 1.15;
        if (season === 'extended') heatFactor *= 1.2;
        if (cover === 'no') heatFactor *= 1.15;
        if (temperature > 30) heatFactor *= 1.15;
        else if (temperature > 28) heatFactor *= 1.08;
        else if (temperature < 27) heatFactor *= 0.95;
        if (heating === 'fast') heatFactor *= 1.15;

        const heatMinimum = roundUp(volume * 1.163 * 0.2 * heatFactor, 0.5);
        const heatRecommended = roundUp(volume * 1.163 * 0.28 * heatFactor, 0.5);
        const hydraulicOption = (flow) => {
          const velocityFor = (innerDiameter) => {
            const radius = innerDiameter / 2000;
            return (flow / 3600) / (Math.PI * radius * radius);
          };
          let pipeSizeIndex = pipeSizes.findIndex((size, index) => {
            const velocity = velocityFor(size.innerDiameter);
            return velocity < 1.35 || (index === pipeSizes.length - 1 && velocity <= 1.5);
          });
          if (pipeSizeIndex < 0) pipeSizeIndex = pipeSizes.length - 1;
          const pipeSize = pipeSizes[pipeSizeIndex];
          const pipeVelocity = velocityFor(pipeSize.innerDiameter);
          const nextPipe = pipeSizeIndex + 1 < pipeSizes.length && (pipeLength > 20 || pipeVelocity >= 1.35)
            ? pipeSizes[pipeSizeIndex + 1]
            : null;
          const requiredFilterDiameter = Math.sqrt((4 * flow) / (Math.PI * 40)) * 1000;
          const filterSizeIndex = filterSizes.findIndex((size) => size >= requiredFilterDiameter);
          const filterDiameter = filterSizeIndex >= 0 ? filterSizes[filterSizeIndex] : filterSizes[filterSizes.length - 1];
          const filterRadius = filterDiameter / 2000;
          return {
            flow,
            pipeSize,
            pipeVelocity,
            nextPipe,
            filterDiameter,
            filterVelocity: flow / (Math.PI * filterRadius * filterRadius)
          };
        };
        const optimal = hydraulicOption(roundUp((volume * 3) / filterHours, 0.5));
        const alternative = hydraulicOption(roundUp((volume * 2.7) / filterHours, 0.5));

        const renderHydraulicOption = (name, option) => {
          root.querySelector(`[data-result-${name}-flow]`).textContent = `${formatNumber(option.flow)} m³/h`;
          root.querySelector(`[data-result-${name}-pipe]`).textContent = `${option.pipeSize.label} (${root.dataset.velocityLabel}: ${formatNumber(option.pipeVelocity, 2)} m/s)`;
          const pipeEfficiency = root.querySelector(`[data-result-${name}-pipe-efficiency]`);
          pipeEfficiency.hidden = !option.nextPipe;
          pipeEfficiency.textContent = option.nextPipe
            ? `${root.dataset.pipeEfficiencyLabel}: ${option.nextPipe.label}`
            : '';
          root.querySelector(`[data-result-${name}-filter]`).textContent = `Ø ${formatNumber(option.filterDiameter, 0)} mm`;
          root.querySelector(`[data-result-${name}-filter-velocity]`).textContent = `${root.dataset.filterVelocityLabel}: ${formatNumber(option.filterVelocity)} m/h`;
        };

        root.querySelector('[data-result-volume]').textContent = `${formatNumber(volume)} m³`;
        root.querySelector('[data-result-heat-min]').textContent = `${formatNumber(heatMinimum)} kW`;
        root.querySelector('[data-result-heat-recommended]').textContent = `${formatNumber(heatRecommended)} kW`;
        renderHydraulicOption('optimal', optimal);
        renderHydraulicOption('alternative', alternative);
        const comparisonLink = root.querySelector('[data-heat-pump-comparison-link]');
        const comparisonUrl = new URL(comparisonLink.getAttribute('href'), window.location.origin);
        comparisonUrl.searchParams.set('min', heatMinimum);
        comparisonUrl.searchParams.set('recommended', heatRecommended);
        comparisonUrl.searchParams.set('volume', volume);
        comparisonLink.href = `${comparisonUrl.pathname}${comparisonUrl.search}`;
        results.hidden = false;

        if (window.matchMedia('(max-width: 999px)').matches) {
          results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    };

    document.querySelectorAll('[data-pwt24-pool-calculator]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pwt24-pool-calculator]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwt24-ratgeber-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeText = (value) => value
      .toLocaleLowerCase('de-DE')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const initialize = (root) => {
      if (root.dataset.searchInitialized === 'true') return;
      root.dataset.searchInitialized = 'true';

      const form = root.querySelector('[data-ratgeber-search-form]');
      const input = root.querySelector('[data-ratgeber-search-input]');
      const entries = Array.from(root.querySelectorAll('[data-ratgeber-entry]'));
      const emptyState = root.querySelector('[data-ratgeber-no-results]');

      if (!form || !input || entries.length === 0 || !emptyState) return;

      const filterEntries = (query, updateUrl = true) => {
        const normalizedQuery = normalizeText(query);
        let visibleEntries = 0;

        entries.forEach((entry) => {
          const matches = normalizeText(entry.textContent).includes(normalizedQuery);
          entry.hidden = !matches;
          if (matches) visibleEntries += 1;
        });

        emptyState.hidden = visibleEntries > 0;

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (query.trim()) url.searchParams.set('q', query.trim());
          else url.searchParams.delete('q');
          window.history.replaceState({}, '', url);
        }
      };

      const initialQuery = new URL(window.location.href).searchParams.get('q') || '';
      input.value = initialQuery;
      filterEntries(initialQuery, false);

      input.addEventListener('input', () => filterEntries(input.value));
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        filterEntries(input.value);
      });
    };

    document.querySelectorAll('[data-ratgeber-index]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ratgeber-index]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
